import MixpanelTracker from 'Mixpanel/mixpanelTracker';
import Action from 'Mixpanel/Model/action';
import { SPEAKERS, SPEAKERS_ADDED } from '../../../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();
export function trackSpeakerUpdate(
  checkboxSelectedCount, speakersAddedCount, imagesUploadedCount,
  namesAddedCount, emailsAddedCount, titlesAddedCount,
  bioAddedCount, organizationAddedCount, fbAddedCount,
  twitterAddedCount, linkedinAddedCount, websiteAddedCount
) {
  const properties = {
    Type: SPEAKERS,
    Action: Action.ADD,
    checkboxSelectedCount,
    speakersAddedCount,
    imagesUploadedCount,
    namesAddedCount,
    emailsAddedCount,
    titlesAddedCount,
    bioAddedCount,
    organizationAddedCount,
    fbAddedCount,
    twitterAddedCount,
    linkedinAddedCount,
    websiteAddedCount
  };
  mixpanelTracker.setEventName(SPEAKERS_ADDED);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
